"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_cpu__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2dfc4ed8-a2d7-43de-9843-b016e1149522",
    "data-name": "Ebene 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1c48b7b7-5c3b-475f-aa20-bb861a89d09b",
    x1: 52.59,
    y1: 139.41,
    x2: 67.41,
    y2: 154.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9ae7352-600c-4275-8f47-49d325858b33",
    x1: 76.59,
    y1: 139.41,
    x2: 91.41,
    y2: 154.24,
    xlinkHref: "#1c48b7b7-5c3b-475f-aa20-bb861a89d09b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "60f871f9-e646-46b5-8b28-1353533d5007",
    x1: 28.59,
    y1: 139.41,
    x2: 43.41,
    y2: 154.24,
    xlinkHref: "#1c48b7b7-5c3b-475f-aa20-bb861a89d09b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7ec48d2-1943-4552-8909-5750fa89cfb6",
    x1: 148.59,
    y1: 139.41,
    x2: 163.41,
    y2: 154.24,
    xlinkHref: "#1c48b7b7-5c3b-475f-aa20-bb861a89d09b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "090fa8ee-974a-4464-930d-3fda0f68a4c3",
    x1: 100.59,
    y1: 139.41,
    x2: 115.41,
    y2: 154.24,
    xlinkHref: "#1c48b7b7-5c3b-475f-aa20-bb861a89d09b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2985d41-9066-410d-af15-259355510067",
    x1: 124.59,
    y1: 139.41,
    x2: 139.41,
    y2: 154.24,
    xlinkHref: "#1c48b7b7-5c3b-475f-aa20-bb861a89d09b"
  })), /*#__PURE__*/React.createElement("title", null, "cpu-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M84,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,84,64Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,108,64Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,132,64Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,156,64Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,60,64Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,36,64Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,84,160Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,108,160Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,132,160Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,156,160Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,60,160Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,36,160Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,84,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,108,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,132,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,156,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,60,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,36,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,84,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,108,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,132,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,156,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,60,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,36,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,56H32a8,8,0,0,0-8,8v64a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8V64A8,8,0,0,0,160,56Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,134H32a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-2A8,8,0,0,1,160,134Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,60,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,84,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,36,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,156,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,108,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,132,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64,136v20a4,4,0,0,1-8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#1c48b7b7-5c3b-475f-aa20-bb861a89d09b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#a9ae7352-600c-4275-8f47-49d325858b33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#60f871f9-e646-46b5-8b28-1353533d5007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,156a4,4,0,0,0,8,0V136h-8Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#b7ec48d2-1943-4552-8909-5750fa89cfb6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#090fa8ee-974a-4464-930d-3fda0f68a4c3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#a2985d41-9066-410d-af15-259355510067)"
  }));
}

var _default = ic_cpu__dark;
exports.default = _default;